import CollectionCard from './CollectionCard';

export default CollectionCard;



// WEBPACK FOOTER //
// ./src/scenes/Collections/components/CollectionCard/index.ts